import React from "react";
import { CSSTransition } from "react-transition-group";
import portalLogo from "./img/hhPortalLogo.png";
import { Wrapper, Container, Logo } from "./styles/portal-header-banner-styles";

const PortalHeader = () => (
  <Wrapper>
    <CSSTransition in appear timeout={300} classNames="fade">
      <Container>
        <Logo src={portalLogo} alt="Portal Logo" />
      </Container>
    </CSSTransition>
  </Wrapper>
);

export default PortalHeader;
